import { ArrowBack } from '@mui/icons-material';
import { Box, Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Translate } from 'react-jhipster';
import { useHistory } from 'react-router-dom';

interface IRegisterButton {
  buttonTranslation?: string;
  disabled?: boolean;
  onBack?: () => void;
}

export const RegisterButton = ({ buttonTranslation, disabled, onBack }: IRegisterButton) => {
  const history = useHistory();
  const isDisabled = disabled === true ? disabled : false;
  const ButtonForm = propsButtonForm => (
    <Button
      {...propsButtonForm}
      sx={{
        gap: '6px',
        margin: '5px',
        padding: '8px 30px;',
        marginLeft: '16px',
        fontSize: '18px ',
        borderRadius: '8px',
        textTransform: 'none',
      }}
    >
      {propsButtonForm.children}
    </Button>
  );

  return (
    <Box display={'flex'} color={'text.primary'} sx={{ justifyContent: 'flex-end', padding: '24px 0px 4px 24px' }}>
      <Button variant={'text'} color="secondary" onClick={onBack ? onBack : () => history.goBack()} startIcon={<ArrowBack />} disabled={isDisabled}>
        <SpanTextButton>
          <Translate contentKey="entity.action.back">Back</Translate>
        </SpanTextButton>
      </Button>

      <ButtonForm variant={'contained'} type="submit" color="secondary" disabled={isDisabled}>
        {isDisabled ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <Translate contentKey={buttonTranslation ? buttonTranslation : 'entity.action.save'}>Save</Translate>
        )}
      </ButtonForm>
    </Box>
  );
};
const SpanTextButton = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
}));
